import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';
import HseTooltip from './HseTooltip.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = HseTooltip;

/* template */
var __vue_render__ = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',_vm._g({ref:"popoverTarget",staticClass:"hse-TooltipTarget"},_vm.listeners),[_vm._t("default")],2),_vm._v(" "),(_vm.isVisible)?_c('HsePopper',_vm._b({staticClass:"hse-Tooltip",class:( _obj = {
      'hse-Tooltip_visible': _vm.isVisible,
      'hse-Tooltip_closable': _vm.closable
    }, _obj[("hse-Tooltip_variant_" + _vm.variant)] = _vm.variant, _obj ),attrs:{"arrow":true,"arrow-color":_vm.arrowColor}},'HsePopper',_vm.popperProps,false),[_c('div',{staticClass:"hse-Tooltip__container"},[_c('div',{staticClass:"hse-Tooltip__content"},[_vm._t("content",[_vm._v("\n          "+_vm._s(_vm.content)+"\n        ")])],2),_vm._v(" "),(_vm.closable)?_c('HseClickableIcon',{staticClass:"hse-Tooltip__closeButton",attrs:{"color":_vm.closeIconColor,"icon":_vm.IconActionDelete,"aria-label":"Закрыть","size":"small"},on:{"click":function($event){return _vm.$emit('close', _vm.$emit)}}}):_vm._e()],1)]):_vm._e()],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
